import { useEffect, useState } from 'react';
import { PopupNotificationMarks } from '../../../const';
import { useNativeFunctionsContext } from '../../../context/native-functions';
import { useUserProfileStore } from '../../../store/user-profile';
import { isProd } from '../../../utils/helpers/environment';
import { diffHours } from '../../../utils/helpers/time-convert';

export const useDialogsShared = () => {
  const { profileData } = useUserProfileStore((s) => s);
  const [evaluatePopupOpen, setEvaluatePopupOpen] = useState<boolean>(false);
  const { nativeAppInstalledPopupOpen, evaluateAppPopupAvailable } = useNativeFunctionsContext();

  useEffect(() => {
    if (profileData?.popupNotificationMarks && evaluateAppPopupAvailable) {
      const popupNotificationMarks = profileData.popupNotificationMarks;
      const evaluateDialogWasDisplayed = popupNotificationMarks.find(
        (x) => x.key === PopupNotificationMarks.EvaluateDialog,
      );

      if (evaluateDialogWasDisplayed) return;

      const evaluateDialogTimeStart = popupNotificationMarks.find(
        (x) => x.key === PopupNotificationMarks.EvaluateDialogTimeStart,
      );

      if (evaluateDialogTimeStart?.at && diffHours(new Date(evaluateDialogTimeStart.at), isProd ? 720 : 24)) {
        setEvaluatePopupOpen(true);
      }
    }
  }, [profileData?.popupNotificationMarks, evaluateAppPopupAvailable]);

  return {
    nativeAppOpen: nativeAppInstalledPopupOpen,
    evaluateAppOpen: evaluatePopupOpen,
    setEvaluatePopupOpen,
  };
};
